<div class="gb-dialog-header">
  <h1>{{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.TITLE' | translate }}</h1>

  <button mat-icon-button mat-dialog-close type="button">
    <gb-icon icon="close"></gb-icon>
  </button>
</div>

<div class="gb-dialog-content">
  <div class="source-tile-grid">
    <div class="source-tile" (click)="selectSource(imageSources.AuctionBanner)">
      <div class="tile-preview">
        @if (isSelectedAuctionLoading) {
          <mat-progress-spinner mode="indeterminate" [diameter]="32"></mat-progress-spinner>
        } @else if (!hasBannerImage) {
          <gb-presenter-widget-placeholder> </gb-presenter-widget-placeholder>
        } @else {
          <gb-image [image]="bannerImageEntity" [cover]="true"></gb-image>
        }
      </div>
      <div class="tile-label">
        <div class="tile-title">
          {{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.SOURCES.BANNER' | translate }}
        </div>
        <div class="tile-subtitle">
          {{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.SUBTITLES.BANNER' | translate }}
        </div>
      </div>
    </div>

    <div class="source-tile" (click)="selectSource(imageSources.AuctionLogo)">
      <div class="tile-preview">
        @if (isSelectedAuctionLoading) {
          <mat-progress-spinner mode="indeterminate" [diameter]="32"></mat-progress-spinner>
        } @else if (!hasLogoImage) {
          <gb-presenter-widget-placeholder> </gb-presenter-widget-placeholder>
        } @else {
          <gb-image [image]="logoImageEntity" [cover]="true"></gb-image>
        }
      </div>
      <div class="tile-label">
        <div class="tile-title">
          {{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.SOURCES.LOGO' | translate }}
        </div>
        <div class="tile-subtitle">
          {{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.SUBTITLES.LOGO' | translate }}
        </div>
      </div>
    </div>

    <div class="source-tile" (click)="selectSource(imageSources.Custom)">
      <div class="upload-icon-container">
        <gb-icon icon="cloud-upload"></gb-icon>
      </div>
      <div class="tile-label">
        <div class="tile-title">
          {{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.CUSTOM_IMAGE' | translate }}
        </div>
        <div class="tile-subtitle">
          {{ 'PRESENTER.IMAGE_WIDGET_SOURCE_DIALOG.UPLOAD_IMAGE_SUBTITLE' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
